import { createSelector } from 'reselect';
import getCurrentOrder from './getCurrentOrder';

const getDeliveryTimeFetchedEstimate = createSelector(
  [getCurrentOrder],
  order => {
    return order.deliveryTimeFetchedEstimateSyncing || false;
  },
);

export default getDeliveryTimeFetchedEstimate;
